import {
    SET_ACTIVE_ORDERS_TAB
} from '../actions/actionTypes';

const initState = {
    tabIndex: 0,
};

const ordersTabsReducer = (state = initState, action) => {
    switch (action.type) {
        case SET_ACTIVE_ORDERS_TAB:
            return Object.assign({}, state, {
                tabIndex: action.tabIndex,
            });
        default:
            return state;
    }
};

export default ordersTabsReducer;
